// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
      	showSuggestionProductVendor: false,
       	suggestionWidth: 300,
      	enableDefaultResult: false
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = getParam(this.searchTermKey);
    if (searchTerm != null) {
        var content = bcSfFilterConfig.label.search_result_number_other;
        if (data.total_product <= 1) {
            var content = bcSfFilterConfig.label.search_result_number_one;
        }
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, getParam(this.searchTermKey));
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};

/***** Customize search & suggestion params *****/
// Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function () {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
  	params.pf_pt_product_type = 'Master';
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) {
        param.skipFields = skipFields;
    }
    params.callback = 'BCSfSuggestionCallback';
    return params;
};

// Prepare Search params
BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
      	console.log('aaa');
        params['q'] = this.escape(this.getSearchTerm());
      	params.pf_pt_product_type = 'Master';
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
    }
    return params;
};

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, data, ul) {
    if (Object.keys(data).length > 0) {
        var limit = this.getSettingValue('search.suggestionProductLimit');
        var category = this.getSettingValue('label.suggestion.productHeader');
        // Build content
        var result = this.buildSuggestionHeader(category, 'product');
        var count = 0;

        for (var k in data) {
            if (count < limit) {
                var product = data[k];
              if(product.product_type == 'Master'){
                if (this.getSettingValue('search.productAvailable') === false || 
                    (this.getSettingValue('search.productAvailable') && product.available)) {
                    // Get product attributes
                    var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, data);
                    productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
                    var productUrl = this.buildProductItemUrl(product, false);
                    var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], 'medium') : bcSfFilterConfig.general.no_image_url;
                    var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
                    // Get custom class / attribute
                    var searchSuggestionClass = this.class.searchSuggestion;
                    var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

                    result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(category) + ': ' + this.escape(product['title']) + '">';
                    result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
                    // Build Left column
                    if (this.getSettingValue('search.showSuggestionProductImage')) {
                        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
                    }
                    // Build Right column
                  	var prodTitle = product.title.split('-');
                    prodTitle = prodTitle[1].split('•');
                    prodTitle = prodTitle[0].split('&');
                  
                    result += '<div class="' + searchSuggestionClass + '-right">';
                  	var topprice = this.getProductMetafield(product, 'product', 'topprice') || '';
                    topprice = (topprice) ? bcsffilter.formatMoney(topprice * 100, bcsffilter.moneyFormat) : '';

                    var toppricesale = this.getProductMetafield(product, 'product', 'toppricesale') || '';
                    toppricesale = (toppricesale) ? bcsffilter.formatMoney(toppricesale * 100, bcsffilter.moneyFormat) : '';

                    var bottomprice = this.getProductMetafield(product, 'product', 'bottomprice') || '';
                    bottomprice = (bottomprice) ? bcsffilter.formatMoney(bottomprice * 100, bcsffilter.moneyFormat) : '';

                    var bottompricesale = this.getProductMetafield(product, 'product', 'bottompricesale') || '';
                    bottompricesale = (bottompricesale) ? bcsffilter.formatMoney(bottompricesale * 100, bcsffilter.moneyFormat) : '';
                  
                  	if (toppricesale == '') {
                        result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[0] + ' '+ '<br/><span class="money">' + topprice + '</span> <BR/></div>';
                    } else {
                        result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[0] + ' ' + '<br/><span style="text-decoration: line-through;"><span class=money>' + topprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + toppricesale + '</span></span> <BR/></div>';
                    }

                    if(product.product_type == 'Master' && prodTitle.length > 1){
                        if (bottompricesale == ''){
                            result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[1] + ' '+ '<br/><span class="money">' + bottomprice + '</span></div>';
                        } else {
                            result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[1] + ' ' + '<br/><span style="text-decoration: line-through;"><span class=money>' + bottomprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + bottompricesale + '</span></span></div>';
                        }
                    }
                  
                    if (this.getSettingValue('search.showSuggestionProductSku')) {
                        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
                    }
                    if (this.getSettingValue('search.showSuggestionProductVendor')) {
                        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
                    }
                    
                    result += '</div>'; // End Right column
                    result += '</a>'; // End a
                    result += '</li>';  // End li

                    count ++;
                }
            } else {
                break;
            }
            }
        }
        return result;
    }
    return '';
};
// Build header of Search result
BCSfFilter.prototype.buildSearchResultHeader = function(data) {
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm !== null && searchTerm != '')  {
        var content = data.total_product > 0 ? this.getSettingValue('label.search.resultHeader') : this.getSettingValue('label.search.resultEmpty');
    } else {
        var content = this.getSettingValue('label.search.generalTitle');
    }
    jQ('.' + this.class.searchResultHeader).html(content.replace(/{{ terms }}/g, searchTerm));
};
// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm !== null && searchTerm != '')  {
        content = this.getSettingValue('label.search.resultNumber');
        content = content.replace(/{{ count }}/g, '<strong>' + data.total_product + '</strong>').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>');
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};
  // Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function () {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) {
        param.skipFields = skipFields;
    }
    params.callback = 'BCSfSuggestionCallback';
    return params;
};
// Fix XSS
BCSfFilter.prototype.customizeSearchTerm = function (searchTerm) {
   return encodeURIParamValue(searchTerm.trim());
};
function BCSfSuggestionCallback(result) {
    suggestionCallback(jQ.map(result, function (item, index) {
        return { key: index, values: item };
    }));
};
// Build Suggestion
/*
BCSfFilter.prototype.buildSuggestion = function(searchTerm, data, ul) {
      searchTerm = this.escape(searchTerm);
    var result = '';
    var blocks = this.getSettingValue('search.suggestionBlocks');
    for (var k = 0; k < blocks.length; k++) {
        var index = this.findIndexArray(blocks[k], data, 'key');
        if (index > -1 && data[index].hasOwnProperty('values') && data[index]['values'].length > 0) {
            switch(blocks[k]) {
                case 'suggestions': result += this.buildSuggestionPopular(searchTerm, data[index]['values'], ul); break;
                case 'products': result += this.buildSuggestionProductList(searchTerm, data[index]['values'], ul); break;
                case 'did_you_mean': result += this.buildSuggestionDidYouMeanList(searchTerm, data[index]['values'], ul); break;
            }
        }
    }
    if (result != '') {
        result += this.buildSuggestionViewAll(searchTerm, data, ul);
    }
    jQ(ul).append(result);

    // Wrapper
    this.buildSuggestionWrapper(ul);
};
*/
// Highlight Text in the Search result
BCSfFilter.prototype.highlightSuggestionResult = function(resultItem, searchTerm) {
    if (this.getSettingValue('search.highlightSuggestionResult') && searchTerm.length > 1) {
        // Find words that are the same with the Search term
        var termElements = searchTerm.split(' ');
        for (var i = 0; i < termElements.length; i++) {
            // Escape the following characters: ( ) { } and .
            var reg = new RegExp(termElements[i].replace(/([(){}.])/g, '\$&'), 'ig');
            var foundWords = resultItem.match(reg);
            if (foundWords !== null && foundWords.length > 0) {
                // Remove duplicate values
                foundWords = foundWords.filter(function(item, pos) {
                    return foundWords.indexOf(item) == pos && item != '';
                })
                // Highlight the above words
                for (var k in foundWords) {
                    if (foundWords[k].length > 1) {
                        var reg = new RegExp(foundWords[k], 'g');
                        resultItem = resultItem.replace(reg, '<b>' + foundWords[k] + '</b>');
                    }
                }
            }
        }
    }
    return resultItem;
};
BCSfFilter.prototype.getSearchTerm = function() {
    return getParam(this.searchTermKey);
};

// /* Start Search Redirect */
// function submitSearchFormMobile(e,t){var i=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm,e,t);bcsffilter.submitSearch(bcsffilter.currentTerm,e,i,t)}function beforeSubmitSearchForm(e,t){var i=jQ(e).val();!i&&t&&t.target&&(i=t.target.value);var s=bcsffilter.getSearchRedirectUrl(i);bcsffilter.submitSearch(i,e,s,t)}BCSfFilter.prototype.buildSearchBox=function(e){this.beforeBuildSearchBox(e);var t=this;if(jQ(e).length>0){var i;i="function"==typeof t.isSuggestionStyle2&&t.isSuggestionStyle2()?t.getSettingValue("search.suggestionStyle2MainContainerSelector")||"header:first":"body";var s=this.currentTerm=getParam(this.searchTermKey);jQ(e).val(s),jQ(e).autocomplete({appendTo:i,minLength:t.getSettingValue("search.suggestionMinLength"),delay:200,source:function(i,s){window.suggestionCallback=s,t.currentTerm=i.term;var r=i.term.trim().replace(/\s+/g," ");""!=r&&t.requestSuggestion(r,e)},classes:{"ui-autocomplete":t.class.searchSuggestion},response:function(i,s){var r=s.content,a=getValueInObjectArray("query",r),o=getValueInObjectArray("event_type",r),n=getValueInObjectArray("suggest_query",r),c=getValueInObjectArray("local_cache",r),u=getValueInObjectArray("redirect",r);25==Object.keys(t.suggestionCache).length&&(t.suggestionCache={}),a in t.suggestionCache||"suggest_dym"==o||(t.suggestionCache[a]=r),""==n||"suggest"!=o||c||t.getSuggestionData(n,0,"suggest_dym",a),t.checkForSearchRedirect(e,u),t.hideSuggestionLoading(e)},focus:function(i,s){return t.focusSuggestionEvent(e,i,s)},open:function(i,s){t.openSuggestionEvent(e,i)},close:function(i,s){t.closeSuggestionEvent(e,i)},select:function(i,s){return t.selectSuggestionEvent(e,i)}}).addClass(t.class.searchBox).attr("data-search-box",e),jQ(e).autocomplete("instance")._renderMenu=function(i,s){return i.attr("data-search-box",e),t.buildSuggestion(this.term,s,i,e)},jQ(e).autocomplete("instance")._resizeMenu=function(){var i=this.menu.element,s=this.element;t.buildStyleSuggestion(i,s,e)},"function"==typeof t.customSearchMenuWidget&&t.customSearchMenuWidget(e),t.clickOutsideSuggestionEvent(e)}this.setSuggestionPosition(e),this.buildSearchBoxEvent(e),"function"==typeof this.afterBuildSearchBox&&this.afterBuildSearchBox(e)},BCSfFilter.prototype.buildSearchBoxEvent=function(e){var t=this;if(jQ(e).length>0&&(jQ(e).on("click",function(i){t.clickSearchBoxEvent(e,i)}).on("focus",function(i){t.focusSearchBoxEvent(e,i)}).on("keyup",function(i){t.typeSearchBoxEvent(e,i)}).on("keydown",function(i){13==i.keyCode&&t.enterSearchBoxEvent(e,i)}),jQ(e).closest("form").length>0)){var i=jQ(e).closest("form").find('[type="submit"]');i&&i.length>0&&i.each(function(t,i){i.setAttribute("onclick","beforeSubmitSearchForm('"+e+"', event)")})}},BCSfFilter.prototype.typeSearchBoxEvent=function(e,t){this.currentTerm=t.target.value,this.checkIsFullWidthSuggestionMobile(e)&&(jQ("."+this.class.searchSuggestion+'[data-search-box="'+e+'"]').parent().show(),""==t.target.value?(closeSuggestionMobile(e),hideClearSuggestionBtn()):showClearSuggestionBtn())},BCSfFilter.prototype.enterSearchBoxEvent=function(e,t){var i=jQ(e).val();!i&&t&&t.target&&(i=t.target.value);var s=this.getSearchRedirectUrl(i);this.submitSearch(i,e,s,t)},BCSfFilter.prototype.buildSuggestion=function(e,t,i,s){e=this.escape(e);var r="",a=getValueInObjectArray("all_empty",t);if(jQ(i).show(),jQ(i).closest("."+this.class.searchSuggestionWrapper).show(),a){getValueInObjectArray("redirect",t)?(jQ(i).hide(),jQ(i).closest("."+this.class.searchSuggestionWrapper).hide()):(r+=this.buildSuggestionNoResult(e,i),jQ(i).append(r))}else{var o=this.getSettingValue("search.suggestionBlocks");if(this.isSuggestionStyle2()&&"products"!=o[0].type){var n=o.findIndex(function(e){return"products"==e.type}),c=o[n];o.splice(n,1),this.getSettingValue("search.suggestionStyle2ReverseProductBlock")?o.push(c):o.unshift(c)}var u,l=o.length;for(u=0;u<l;u++){var g=o[u];if(g.hasOwnProperty("status")&&"active"==g.status){var h=this.findIndexArray(g.type,t,"key");if(h>-1&&t[h].hasOwnProperty("values")){var f=t[h],p='<li class="bc-sf-search-suggestion-group" data-group="'+g.type+'" aria-label="'+o[u].label+'"><ul>';switch(g.type){case"suggestions":p+=this.buildSuggestionPopular(e,f.values,i,g,t);break;case"products":p+=this.buildSuggestionProductList(e,f.values,i,g,t);break;case"pages":p+=this.buildSuggestionPage(e,f.values,i,g,t);break;case"collections":p+=this.buildSuggestionCollection(e,f.values,i,g,t)}p+="</ul></li>",jQ(i).append(p)}}}if(""===getValueInObjectArray("suggest_query",t)){var S=this.buildSuggestionViewAll(e,t,i);jQ(i).append(S)}}jQ(i).find("."+this.class.searchSuggestionItem+"[data-label]").each(function(){var e=jQ(this).data("label")||"",t=jQ(this).data("value")||"";""!==t&&jQ(this).data("ui-autocomplete-item",{label:e.toString(),value:t}).addClass("bc-ui-item")}),this.buildSuggestionWrapper(i,s)},BCSfFilter.prototype.checkForSearchRedirect=function(e,t){jQ(e).data("search-submit")&&(jQ(e).removeData("search-submit"),t?(t=(t=t.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,""),window.location.href=t):jQ(e).closest("form").submit())},BCSfFilter.prototype.getSearchRedirectUrl=function(e){var t="";if(e&&("string"!=typeof e&&(e=e.toString()),e=e.trim().toLowerCase(),this.suggestionCache.hasOwnProperty(e)))for(var i=this.suggestionCache[e],s=0;s<i.length;s++)"redirect"==i[s].key&&i[s].values&&(t=(t=(t=i[s].values).replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,""));return t},BCSfFilter.prototype.submitSearch=function(e,t,i,s){s.stopImmediatePropagation(),s.stopPropagation(),s.preventDefault(),this.suggestionCache.hasOwnProperty(e.toString().trim().toLowerCase())?i?window.location.href=i:jQ(t).closest("form").submit():jQ(t).closest('input[name="'+this.searchTermKey+'"]').data("search-submit",!0)};
// /* End Search Redirect */

